<template>
  <div>
    <navbar>
      <template #before>
        <router-link to="/" class="btn btn-sm btn-outline-light">
          Home
        </router-link>
      </template>
      <template #title>
        <span class="navbar-brand">Admin » Users</span>
      </template>
      <div class="d-flex">
        <router-link
          to="/admin/products"
          class="btn btn-sm btn-outline-light"
        >
          Products
        </router-link>
        <router-link
          to="/admin/users/create"
          class="btn btn-sm btn-outline-light ms-2"
        >
          Add User
        </router-link>
      </div>
    </navbar>
    <container>
      <div v-if="loading" class="text-center my-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else-if="error" class="alert alert-danger my-3">
        {{ error }}
      </div>
      <div v-else class="my-3">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Admin</th>
                <th>Active</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>
                  <span class="badge" :class="user.is_admin ? 'bg-success' : 'bg-secondary'">
                    {{ user.is_admin ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td>
                  <span class="badge" :class="user.is_active ? 'bg-success' : 'bg-danger'">
                    {{ user.is_active ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td>{{ formatDate(user.created_at) }}</td>
                <td>
                  <button
                    @click="deleteUser(user)"
                    class="btn btn-sm btn-danger"
                    :disabled="deleting === user.id"
                  >
                    <span v-if="deleting === user.id">Deleting...</span>
                    <span v-else>Delete</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="users.length === 0" class="text-center text-muted my-3">
          No users found
        </div>
      </div>
    </container>
  </div>
</template>

<script>
export default {
  name: "AdminUsers",
  data: () => ({
    users: [],
    loading: false,
    error: null,
    deleting: null
  }),
  methods: {
    async loadUsers() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await this.axios.get("/api/users/admin-index.json");
        this.users = data.users;
      } catch (error) {
        this.error = "Failed to load users: " + (error.response?.data?.error || error.message);
      } finally {
        this.loading = false;
      }
    },
    async deleteUser(user) {
      if (!confirm(`Are you sure you want to delete ${user.name}?`)) {
        return;
      }
      
      this.deleting = user.id;
      try {
        await this.axios.post(`/api/users/admin-delete/${user.id}.json`);
        this.users = this.users.filter(u => u.id !== user.id);
      } catch (error) {
        alert("Failed to delete user: " + (error.response?.data?.error || error.message));
      } finally {
        this.deleting = null;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }
  },
  mounted() {
    this.loadUsers();
  }
};
</script>
